export const roles = [
  {
    id: 1,
    name: 'Admin',
    description: 'Can manage incidents, create campaigns and change settings',
  },
  {
    id: 3,
    name: 'Campaign Editor',
    description: 'Can manage and launch campaigns',
  },
  {
    id: 2,
    name: 'Incident Manager',
    description: 'Can manage incidents and view settings',
  },
  {
    id: 5,
    name: 'Incident Operator',
    label: 'Incident Operator',
    description: 'Can manage incidents',
  },
  {
    id: 4,
    name: 'Incident Viewer',
    description: 'Can view incidents',
  },
]

export const NONE_ROLE_OPTION = { value: 0, name: 'None' }

export const rolesOptions = roles.map((r) => ({ value: r.id, label: r.name }))

export const OWNER_ROLE = { id: 99999, name: 'Owner' }
export const rolesAndOwner = [OWNER_ROLE, ...roles]

export const getRoleNameById = (id, relevantRoles = roles) =>
  relevantRoles.find((r) => r.id === id).name
